<!-- <p>app-config works!</p>-->
<ng-template #PageLoadingTemplate>
    <app-loading-template DisplayText="Please wait while we load site configuration" />
</ng-template>
<div class="application-configuration" *ngIf="appConfig else PageLoadingTemplate">

    <div class="contents-box">
        <div class="page-header">
            <div>
                <h1>Application Configuration</h1>
                <p>Configure application-wide settings.</p>
            </div>
        </div>


        <!-- Maintenance -->
        <hr>
        <mat-card class="configuration-card">

            <mat-card-header>
                <mat-card-title>Maintenance</mat-card-title>
                <mat-card-subtitle>
                    Control when the application is placed into maintenance mode.
                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>

                <div class="configuration-section">

                    <mat-slide-toggle color="primary" [(ngModel)]="appConfig.maintenance.enabled">
                        Enable maintenance mode
                    </mat-slide-toggle>

                    <div class="setting-description">
                        When enabled, users will be shown the maintenance page
                        during the configured maintenance period.
                    </div>

                </div>


                <div class="configuration-section">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Maintenance message</mat-label>
                        <textarea matInput rows="3" [(ngModel)]="appConfig.maintenance.message">
                    </textarea>
                    </mat-form-field>
                </div>


                <div class="date-row">

                    <mat-form-field appearance="outline">

                        <mat-label>Start</mat-label>
                        <!-- [min]="getDateTimeLocal(Date.now())"  -->
                        <input matInput type="datetime-local"
                            [value]="getDateTimeLocal(appConfig.maintenance.start)" (change)="setStartDate($event)"
                            #startDateInput>

                        <div class="date-error" *ngIf="startDateInvalid">
                            Maintenance start time in the past.
                        </div>

                    </mat-form-field>


                    <mat-form-field appearance="outline">

                        <mat-label>End</mat-label>

                        <input matInput type="datetime-local" [value]="getDateTimeLocal(appConfig.maintenance.end)"
                            (change)="setEndDate($event)">

                        <div class="date-error" *ngIf="endDateInvalid">
                            Check the Stat is before End.
                        </div>
                    </mat-form-field>

                </div>

            </mat-card-content>

        </mat-card>


        <!-- Deployment -->
        <hr>
        <mat-card class="configuration-card">

            <mat-card-header>
                <mat-card-title>Deployment</mat-card-title>
                <mat-card-subtitle>
                    Configure application deployment behaviour.
                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>

                <div class="configuration-section">

                    <mat-slide-toggle color="primary" [(ngModel)]="appConfig.deployment.silent">
                        Silent deployment
                    </mat-slide-toggle>

                    <div class="setting-description">
                        Prevent deployment notifications from being displayed
                        to users.
                    </div>

                </div>

            </mat-card-content>

        </mat-card>


        <!-- Actions -->
        <hr>
        <div class="actions">

            <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">

                Cancel

            </button>

            <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">

                <mat-spinner *ngIf="saving" diameter="20" />
                <span>{{saving ? 'Saving...': 'Save Configuration'}}</span>
                <!-- <span *ngIf="saving">Saving...</span> -->

            </button>

        </div>
    </div>
</div>